import moment from "moment";
import React from "react";
import { Link } from "react-router-dom";

const EmailListItem = ({
  isUnread,
  isStarred,
  senderName,
  senderPhone,
  noOfPages,
  date,
  isChecked = false,
  index,
  handleSelectMessage,
  handleStarred,
  detailId,
  onNavigateToDetail,
}) => {
  return (
    <li
      className={isUnread == 0 ? "unread" : "read"}
      onClick={() => {
        if (onNavigateToDetail) {
          onNavigateToDetail(detailId);
        }
      }}
      style={{ cursor: "pointer" }}
    >
      <div className="col-mail col-mail-1">
        <div className="checkbox-wrapper-mail">
          <input
            type="checkbox"
            id={index}
            checked={!!isChecked}
            onChange={(e) => {
              e.stopPropagation();
              handleSelectMessage(index);
            }}
            onClick={(e) => e.stopPropagation()}
          />
          <label
            htmlFor={index}
            className="toggle"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
        {isStarred == 1 ? (
          <i
            className="star-toggle fa fa-star text-warning"
            aria-hidden="true"
            style={{ cursor: "pointer" }}
            onClick={(e) => {
              e.stopPropagation();
              handleStarred(index, "starRemove");
            }}
          ></i>
        ) : isStarred == 0 ? (
          <i
            className="star-toggle fa fa-star-o"
            aria-hidden="true"
            style={{ cursor: "pointer" }}
            onClick={(e) => {
              e.stopPropagation();
              handleStarred(index, "starAdd");
            }}
          ></i>
        ) : (
          ""
        )}
        <div className="title">
          <span className="senderName">{senderName}</span>
          <span className="ms-2">
            <i className="mdi mdi-fax me-1" />
            {senderPhone}
          </span>
        </div>
      </div>
      <div className="col-mail col-mail-2">
        {`${noOfPages} Pages`}
        <div className="date" style={{ paddingLeft: 40 }}>
          {moment(date).format("DD MMM - hh:mm A")}
        </div>
      </div>
    </li>
  );
};

export default EmailListItem;
